// Helper PURO del media plan (sin React): módulo propio para poder testearlo sin montar la
// pantalla de la propuesta, igual que `panelFormatters` en el Panel.

/**
 * Resumen de la propuesta para el encabezado de tarea del shell (UX 2.1, card gtAL5axI paso 5).
 *
 * `pending` espeja la definición del BACKEND (`MediaPlanProposalItemQuerySet.pending_counts_by_client`,
 * la misma que alimenta `media_plan.pending_items` del agregado del Panel): ítems en PENDING_REVIEW
 * de una propuesta VIVA (OPEN o PARTIALLY_APPLIED). Si las dos pantallas contaran distinto, la card
 * del Panel diría un número y esta pantalla otro para "lo mismo".
 *
 * `linkable` = cards de CREATE pendientes que ofrecen decisión de destino (`link_candidates`): es
 * lo que hace aparecer "Vincular líneas existentes" en el encabezado.
 *
 * Las filas del plan que no se siguen (`payload.untracked_rows`, tanda «grupos, dinero y DV360») NO
 * cuentan: viven dentro del payload de su línea y no son items. Antes una plataforma sin canal era una
 * duda bloqueante que sumaba acá sin que hubiera nada que responder.
 */
export function proposalSummary(proposal) {
    const alive = proposal
        && (proposal.status === 'OPEN' || proposal.status === 'PARTIALLY_APPLIED');
    const items = alive ? (proposal.items || []) : [];
    const pendingItems = items.filter((i) => i.review_status === 'PENDING_REVIEW');
    return {
        pending: pendingItems.length,
        linkable: pendingItems.filter((i) => i.action_type === 'CREATE_BU'
            && ((i.payload || {}).link_candidates || []).length > 0).length,
    };
}
